import { render, staticRenderFns } from "./wajaran.vue?vue&type=template&id=b33b5978"
import script from "./wajaran.vue?vue&type=script&lang=js"
export * from "./wajaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports